import { render, staticRenderFns } from "./KeyboardForVue.vue?vue&type=template&id=c12ce900&scoped=true&"
import script from "./KeyboardForVue.vue?vue&type=script&lang=js&"
export * from "./KeyboardForVue.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardForVue.vue?vue&type=style&index=0&id=c12ce900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12ce900",
  null
  
)

export default component.exports